import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

/**
 * Service for sh-invoice related API calls
 */
export default Service.extend({
  api: service(),
  store: service(),
  shData: service(),

  /**
   * Add an invoice line item
   *
   * @param {ShInvoice} shInvoice
   * @param {String} type     of type ShBillableLineItem.TYPES.*
   * @param {Number} amount
   * @param {String} description
   * @return {Ember.RSVP.Promise}
   */
  addInvoiceLineItem(shInvoice, type, amount, description) {
    let options = {
      jsonData: {
        'type' : type,
        'amount' : amount,
        'description': description
      }
    };

    this.shData.addIncludesToOptions(options, []);

    return this.get('api').post(`sh-invoices/${shInvoice.get('id')}/sh-invoice-line-items`, options).then(response => {
      this.shData.pushResponseToStore(response);
      const shInvoiceLineItem = this.get('store').peekRecord('shInvoiceLineItem', response.data.id);
      return shInvoiceLineItem;
    }).catch(e => {
      handleErrorResponseWithModal(
        this,
        e,
        'There was an error creating the line item. Please refresh and try again.',
        'addInvoiceLineItem -- error creating invoice line item for invoice id : ' + shInvoice.get('id'),
      );
      throw e;
    });
  },

  /**
   * Delete an shInvoiceLineItem
   *
   * @param {ShInvoiceLineItem} shInvoiceLineItem
   * @return {Ember.RSVP.Promise}
   */
  deleteInvoiceLineItem(shInvoiceLineItem) {
    let options = {};

    this.shData.addIncludesToOptions(options, []);

    return new Promise((resolve, reject) => {
      this.get('api').delete(`sh-invoice-line-items/${shInvoiceLineItem.get('id')}`, options).then(() => {
        resolve(true);
      }).catch(e => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error deleting the line item. Please refresh and try again.',
          'deleteInvoiceLineItem -- error deleting invoice line item for line item id : ' + shInvoiceLineItem.get('id'),
        );
        reject(e);
      });
    });
  },

  /**
   * Update an shInvoiceLineItem
   *
   * @param {ShInvoiceLineItem} shInvoiceLineItem
   * @param {Number} amount
   * @param {String} description
   * @return {Ember.RSVP.Promise}
   */
  updateInvoiceLineItem(shInvoiceLineItem, amount, description) {
    let options = {
      jsonData: {
        'amount' : amount,
        'description': description
      }
    };

    this.shData.addIncludesToOptions(options, []);

    return new Promise((resolve, reject) => {
      this.get('api').put(`sh-invoice-line-items/${shInvoiceLineItem.get('id')}`, options).then(response => {
        shInvoiceLineItem.set('amount', amount);
        shInvoiceLineItem.set('description', description);
        resolve(shInvoiceLineItem);
      }).catch(e => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error updating the line item. Please refresh and try again.',
          'updateInvoiceLineItem -- error updating invoice line item for line item id : ' + shInvoiceLineItem.get('id'),
        );
        reject(e);
      });
    });
  }
});
